import logo from './gatsby.svg'
import TextStyles from './text-styles@2x.png'
import Yummygum from './yummygum-avatar-circle.svg'
import Cleaner from './cleaner@2x.png'
import Confetti from './sketchconfetti@2x.png'

export default {
  TextStyles,
  Yummygum,
  Cleaner,
  Confetti,
}



// WEBPACK FOOTER //
// ./src/images/index.js